export default "__VITE_ASSET__DkUf2K$0__"